import React, {useState, useCallback, useEffect} from 'react';
import { useForm } from 'react-hook-form';
import { useMutation } from '@apollo/client';
import DataState from 'app/src/components/DataState';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup, ButtonContainer } from 'app/src/elements/buttons';
import { View, Text } from 'react-native';
import { CREATE_FEE, CREATE_TITLE_LOG, SELECTS } from './queries';
import Autocomplete from '../Autocomplete';
import { TITLE_LOG_STATUSES } from '.';
import NewAttachment from '../Attachments/new';
import NewLinkedAttachment from '../Attachments/LinkedAttachments/new';
import { formatBuyerInfo } from '../../utils/formatAssetName';
import { PageTitle } from '../../elements';
import { numberWithDelimiter } from 'app/src/utils/stringHelpers';
import { Warning, WarningText } from 'app/src/styles';

const NewTitleLog = ({setShowModal, refetch, knownTitleLog, assetId, knownAsset}) => {
  const [submitting, setSubmitting] = useState();
  const [titleLog, setTitleLog] = useState(knownTitleLog);
  const [assets, setAssets] = useState();
  const [asset, setAsset] = useState(knownAsset || '');
  const [showLinkedAttachment, setShowLinkedAttachment] = useState(false);
  const [createTitleLog] = useMutation(CREATE_TITLE_LOG, {
    onCompleted: () => {
      setShowModal(false);
      if(refetch) {
        refetch();
      }
    }
  });

  const onSubmit = useCallback(input => {
    setSubmitting(true);
    if(input.upload === '') {
      delete input['upload']
    }
    createTitleLog({ variables: input });
  });

  const { control, handleSubmit, getValues, setValue, register, watch,
    formState: { errors }
  } = useForm({
    defaultValues: {
      assetId: assetId || '',
      status: '',
      upload: '',
      titleNumber: '',
      state: '',
      trackingNumber: '',
      trackingShipper: '',
      sendTrackingEmail: true,
      notes: '',
      linkedAttachment: null,
    }
  });

  const watchStatus = watch('status');
  const watchTrackingNumber = watch('trackingNumber');

  const canSendTrackingEmail = watchTrackingNumber && 'Release' === watchStatus;

  return (
    <View>
      {submitting ?
        <DataState.Loading /> :
        <View>
          {
            asset && ["Sold", "Sold Direct"].includes(asset.status) &&
              formatBuyerInfo(asset)
          }
          { assetId ?
            <></>
            :
            <Autocomplete
              label={'Asset'}
              placeHolder={''}
              resource={'Asset'}
              options={assets}
              setValue={setValue}
              setResource={setAsset}
              name='assetId'
              {...register("assetId", {
                required: "Required"
              })}
            />
          }
          <Input.Picker
            label="Status:"
            name="status"
            options={
              TITLE_LOG_STATUSES.map(tls => { return { value: tls, label: tls }})
            }
            control={control}
            errors={errors}
            {...register("status", {
              required: "Required"
            })}
          />
          {'Release' == watchStatus && asset.titleReleaseWarning && (
            <Warning>
              <WarningText>
                WARNING: {asset.titleReleaseWarning}
              </WarningText>
            </Warning>
          )}
          <Input.Text
            label="Title Number:"
            name="titleNumber"
            control={control}
            errors={errors}
          />
          <Input.StatePicker
            label="State:"
            name="state"
            control={control}
            errors={errors}
          />
          <View>
            <Text>
              <b>Odometer:</b>
              {asset && asset?.miles > 0 ?
                numberWithDelimiter(asset?.miles) :
                ' No Mileage Entered'
              }
            </Text>
            <br />
          </View>
          <Input.Picker
            label="Shipping Company:"
            name="trackingShipper"
            options={
              ['Fedex', 'UPS', 'USPS'].map(shipper => (
                { value: shipper, label: shipper }
              ))
            }
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Tracking Number:"
            name="trackingNumber"
            control={control}
            errors={errors}
          />
          {canSendTrackingEmail && (
            asset?.buyer?.email ? (
              <Input.Checkbox
                label={`Email Tracking Number to Buyer (${asset.buyer.email})?`}
                name="sendTrackingEmail"
                control={control}
                errors={errors}
              />
            ) : (
              <Text>No buyer email. Cannot send tracking number</Text>
            )
          )}
          <Input.Text
            label="Notes:"
            name="notes"
            control={control}
            errors={errors}
          />
          <NewAttachment
            recordId={getValues('assetId')}
            recordType='Title Log'
            attachmentType='Title Log'
            refetch={refetch}
            name='upload'
            setValue={setValue}
          />
          <b>OR</b>
          <NewLinkedAttachment
            resourceId={getValues('assetId')}
            resourceType={'Asset'}
            attachmentType={'TitleLog'}
            setShowModal={setShowLinkedAttachment}
            setValue={setValue}
          />
          <ButtonContainer>
            <ButtonGroup>
              <Button label="Create Title Log" onPress={handleSubmit(onSubmit)} />
            </ButtonGroup>
          </ButtonContainer>
        </View>
      }
    </View>
  )
}

export default NewTitleLog;
